module.exports = __webpack_public_path__ + "img/mic-lock.1c4909d6.svg";